import { TParserKafkaUtils } from '../types'
import { OpenAPIV2 } from 'openapi-types'
import { capitalize } from '@obvious.tech/util/string'

const getTopicList = (swaggerfiles: OpenAPIV2.Document): string[] => {
  const entities = Object.keys(swaggerfiles.paths)
    .map(path => ({
      microservice: path.split('/')[1],
      entity: path.split('/')[3],
    }))
    .filter(
      (entity, index, currentArray) =>
        currentArray.findIndex(
          tmp =>
            entity.microservice === tmp.microservice &&
            entity.entity === tmp.entity,
        ) === index,
    )

  return entities.reduce<string[]>((acc, entity, index) => {
    const firstSameEntityIndex = entities.findIndex(
      tmp => tmp.entity === entity.entity,
    )
    const secondSameEntityIndex = entities
      .slice(firstSameEntityIndex + 1)
      .findIndex(tmp => {
        return tmp.entity === entity.entity
      })
    if (firstSameEntityIndex !== index || secondSameEntityIndex !== -1) {
      return [...acc, `Event${capitalize(entity.microservice)}${entity.entity}`]
    } else {
      return [...acc, `Event${entity.entity}`]
    }
  }, [])
}

export default (swaggerfiles: OpenAPIV2.Document): TParserKafkaUtils => {
  return {
    getTopicList: () => getTopicList(swaggerfiles),
  }
}
